import { returnPolicyPropertiesFromDataset } from "../helpers/returnPolicyProperties";
import { cartItemTracking, sourceFromDataset } from "../helpers/dataLayer";

class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      const button = e.target.closest("[data-add]");
      if (button) this.add(button);
    });
  }

  add(button) {
    if (button.disabled) return;

    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    window.addToCart(
      {
        id: button.dataset.variantId,
        quantity: 1,
        properties: returnPolicyPropertiesFromDataset(button.dataset),
        tracking: cartItemTracking(sourceFromDataset(button.dataset)),
      },
      {
        onAfterAdd: (response) => {
          const key = response?.items?.[0]?.key;
          if (key) this.scrollToItem(key);
        },
        // The cart morph drops the row on success, so only the failure path has
        // a button left to restore.
        onError: (response) => {
          button.disabled = false;
          button.removeAttribute("aria-busy");
          this.showError(
            button.closest(".cart-upsell__item") || this,
            response?.message || window.localeStrings.product.add_to_cart_error,
          );
        },
      },
    );
  }

  /**
   * Bring the line that was just added into view — it sits above the upsell, so
   * nothing about the add is visible from down here otherwise.
   *
   * The cart hasn't painted yet: the add response arrives before the cart
   * payload the morph runs on. cart-content registered its own updateCart
   * listener at load, so by the time this one fires the row exists.
   *
   * @param {string} key the added line item's key
   */
  scrollToItem(key) {
    // On the cart page the drawer's cart is in the DOM too, and this element
    // may itself be morphed away once its last row is in the bag.
    const cart = this.closest("cart-content");

    document.addEventListener(
      "updateCart",
      () => {
        cart
          ?.querySelector(`[data-item-key="${key}"]`)
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      },
      { once: true },
    );
  }

  showError(target, message) {
    const error = document.createElement("div");
    error.classList.add("add-to-cart-error");
    error.innerHTML = message;

    target.append(error);

    setTimeout(() => error.remove(), 3000);
  }
}

if (!customElements.get("cart-upsell")) {
  customElements.define("cart-upsell", CartUpsell);
}
